<template>
  <v-tooltip
    v-if="classificationStatus"
    location="top center"
    :disabled="!classificationFailureReason"
    :text="classificationFailureReason"
  >
    <template v-slot:activator="{ props: tooltipProps }">
      <v-chip
        v-bind="tooltipProps"
        class="text-uppercase"
        :color="color"
        density="comfortable"
        label
        title="Email classification status"
      >
        <v-icon icon="mdi-information-outline" start />
        {{ classificationStatus.replaceAll('_', ' ') }}
      </v-chip>
    </template>
  </v-tooltip>
</template>

<script setup lang="ts">
export interface Props {
  classificationStatus: string | null
  classificationFailureReason?: string | undefined
}
const props = defineProps<Props>()

const color = computed(() => {
  switch (props.classificationStatus) {
    case 'action_in_progress':
      return 'warning'
    case 'analysing_document':
      return 'warning'
    case 'action_completed':
      return 'dark-green'
    default:
      return ''
  }
})
</script>
<style>
.report-overlay div{
  opacity: 1 !important;
}
</style>
